<script>
    import R, {LOADER} from "../lib/requests";
    import {LOCATION_TYPE} from "../lib/constants";
    import Notifier from "../stores/notifier";

    export let location;
    export let locations;

    let list = null;
    let locationId = null;

    const load = () => {
        const onSuccess = result => {
            list = [];
            locations.map(item => {
                if (item.id != location.id && (item.is_local == 1)) {
                    let loc = result.find(x => x.id == item.id);
                    list.push({
                        pickup_id: location.id,
                        drop_id: item.id,
                        name: item.name,
                        parent_name: item.parent_name,
                        price: loc ? loc.price : null
                    });
                }
            });
        }

        const onFailure = err => {
        };

        R.handle(R.location.loadLocalPrices, location.id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onPriceChange = (item) => {
        const onSuccess = result => {
            if (result < 0) {
                Notifier.showMessage("Local price deleted");
            } else if (result == 0) {
                Notifier.showMessage("Local price updated");
            } else {
                Notifier.showMessage("Local price added");
            }
        }

        const onFailure = err => {
        };

        if (item.price) {
            item.price = item.price.replace(",", ".");
        }

        let data = {
            pickup_id: item.pickup_id,
            drop_id: item.drop_id,
            price: item.price
        }

        R.handle(R.location.editLocalPrice, data, onSuccess, onFailure, LOADER.NONE);
    }

    const close = () => {
        location = null;
        locationId = null;
    }

    $: if (location && locationId != location.id) {
        locationId = location.id;
        load();
    }
</script>

<div class="panel panel-default">
    <div class="panel-heading">
        Local Taxi Prices
        <div class="panel-close" on:click={ close }>
            &times;
        </div>
    </div>
    <div class="panel-body p-3">
        <small>from</small>
        <h5 class="mb-0">{ location.name }</h5>
    </div>
    {#if list && list.length}
        <table class="table table-list local-prices">
            <thead>
                <tr>
                    <th>DESTINATION</th>
                    <th>PRICE</th>
                </tr>
            </thead>
            <tbody>
            {#each list as item}
                <tr>
                    <td class="py-2">
                        <div class="small">{ item.parent_name }</div>
                        { item.name }
                    </td>
                    <td class="price-column px-1 py-2">
                        <input type="text" class="form-control minimal" bind:value="{ item.price }"
                               oninput="this.value = this.value.replace(/[^0-9.,]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
                               on:change="{ () => onPriceChange(item) }"
                               autocomplete="off">
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
    {/if}
</div>